import { DateTimePicker, DateTimePickerProps } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

export const UTCDateTimePicker = (
  props: DateTimePickerProps<Dayjs> & React.RefAttributes<HTMLDivElement>
) => {
  
  return (
    <DateTimePicker
      {...props}
      onChange={(args) => {
        // Settings.defaultZone = timezone;
        // @ts-ignore
        props.onChange(args);
      }}
      slotProps={{
        textField: {
          inputProps: {
            placeholder: 'YYYY/MM/DD HH:mm'
          }
        }
      }}
      timezone={"UTC"}
    />
  );
};
